import { MainLayoutComponent } from './main-layout/main-layout.component';
import { ChangePasswordComponent } from '@ml/core/containers/change-password/change-password.component';
import { ChangePasswordPageComponent } from '@ml/core/containers/change-password/change-password-page.component';

export const containers = [MainLayoutComponent, ChangePasswordComponent, ChangePasswordPageComponent];

export * from './main-layout/main-layout.component';
export * from './change-password/change-password.component';
export * from './change-password/change-password-page.component';
